import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'zero-waste-legal-notice',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  template: `
    <div class="legal-notice-container">
      <div class="container">
        <h1 class="title">Mentions légales – Zero Waste Pro</h1>

        <div class="content">
          <p class="intro">
            Conformément aux dispositions des articles 6-III et 19 de la Loi
            n°2004-575 du 21 juin 2004 pour la confiance dans l'économie
            numérique (LCEN), il est porté à la connaissance des utilisateurs et
            visiteurs du site www.zero-waste.pro les présentes mentions légales.
          </p>

          <section class="section">
            <h2>1. Éditeur du site</h2>
            <ul>
              <li>Nom : Mohamed Oussema Njimi</li>
              <li>Statut : Entrepreneur individuel</li>
              <li>Adresse : 7 montée du château, Hesperange, Luxembourg</li>
              <li>Email : med.oussema.njimi&#64;zero-waste.pro</li>
              <li>Téléphone : +33 7 66 82 46 98</li>
              <li>Directeur de la publication : Mohamed Oussema Njimi</li>
            </ul>
          </section>

          <section class="section">
            <h2>2. Hébergement</h2>
            <ul>
              <li>Hébergeur : OVH</li>
              <li>Société : OVH SAS</li>
              <li>Adresse : 2 rue Kellermann, 59100 Roubaix, France</li>
              <li>Site web : www.ovh.com</li>
              <li>Téléphone : 1007 (appel non surtaxé depuis la France)</li>
            </ul>
          </section>

          <section class="section">
            <h2>3. Propriété intellectuelle</h2>
            <p>
              L'ensemble du contenu présent sur le site www.zero-waste.pro,
              incluant de façon non limitative les graphismes, images, textes,
              vidéos, logos et icônes, est la propriété exclusive de Mohamed
              Oussema Njimi, sauf mentions contraires.
            </p>
            <p>
              Toute reproduction, distribution, modification, adaptation,
              retransmission ou publication de ces éléments, même partielle, est
              strictement interdite sans l'accord exprès par écrit de l'éditeur.
            </p>
          </section>

          <section class="section">
            <h2>4. Responsabilités</h2>
            <p>
              Le propriétaire du site s'efforce de fournir sur
              www.zero-waste.pro des informations aussi précises que possible.
              Toutefois, il ne pourra être tenu responsable des omissions,
              inexactitudes ou carences dans la mise à jour, qu'elles soient de
              son fait ou du fait des tiers partenaires qui lui fournissent ces
              informations.
            </p>
            <p>
              L'utilisateur du site s'engage à y accéder avec un matériel
              récent, ne contenant pas de virus et avec un navigateur de
              dernière génération mis à jour.
            </p>
          </section>

          <section class="section">
            <h2>5. Données personnelles</h2>
            <p>
              Les données personnelles éventuellement collectées sur le site
              (via formulaire de contact ou inscription à une newsletter) sont
              destinées uniquement à un usage interne.
            </p>
            <p>
              Conformément au Règlement Général sur la Protection des Données
              (RGPD – UE 2016/679), vous disposez d'un droit d'accès, de
              rectification, d'effacement et d'opposition aux données vous
              concernant.
            </p>
            <p>
              Vous pouvez exercer ces droits en envoyant un email à :
              med.oussema.njimi&#64;zero-waste.pro
            </p>
          </section>

          <section class="section">
            <h2>6. Cookies</h2>
            <p>
              Le site www.zero-waste.pro peut utiliser des cookies à des fins de
              mesure d'audience ou d'amélioration de l'expérience utilisateur.
            </p>
            <p>
              L'utilisateur peut configurer son navigateur pour désactiver les
              cookies s'il le souhaite.
            </p>
          </section>

          <section class="section">
            <h2>7. Droit applicable</h2>
            <p>
              Tout litige en relation avec l'utilisation du site
              www.zero-waste.pro est soumis au droit luxembourgeois.
            </p>
          </section>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .legal-notice-container {
        padding: 120px 0 60px;
        background-color: var(--light-color);
        min-height: 100vh;
      }

      .title {
        color: var(--primary-color);
        font-size: 2.5rem;
        margin-bottom: 2rem;
        text-align: center;
      }

      .content {
        background: white;
        padding: 2rem;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      }

      .intro {
        font-size: 1.1rem;
        line-height: 1.6;
        margin-bottom: 2rem;
        color: var(--text-color);
      }

      .section {
        margin-bottom: 2rem;
        padding-bottom: 2rem;
        border-bottom: 1px solid #eee;

        &:last-child {
          border-bottom: none;
          margin-bottom: 0;
          padding-bottom: 0;
        }
      }

      h2 {
        color: var(--primary-color);
        font-size: 1.5rem;
        margin-bottom: 1rem;
      }

      p {
        line-height: 1.6;
        margin-bottom: 1rem;
        color: var(--text-color);
      }

      ul {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
          margin-bottom: 0.5rem;
          padding-left: 1.5rem;
          position: relative;
          color: var(--text-color);

          &:before {
            content: '•';
            color: var(--primary-color);
            position: absolute;
            left: 0;
          }
        }
      }

      @media (max-width: 768px) {
        .legal-notice-container {
          padding: 100px 0 40px;
        }

        .title {
          font-size: 2rem;
        }

        .content {
          padding: 1.5rem;
        }

        h2 {
          font-size: 1.3rem;
        }
      }
    `,
  ],
})
export class LegalNoticeComponent {}
